import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ShieldCheck } from "lucide-react";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("pg_cookie_consent")) setVisible(true);
  }, []);

  const choose = async (choice) => {
    localStorage.setItem("pg_cookie_consent", choice);
    setVisible(false);
    try { await api.post("/consent", { choice }); } catch {}
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-4 inset-x-4 z-[70] max-w-3xl mx-auto" data-testid="cookie-consent">
      <div className="rounded-2xl p-5 shadow-2xl backdrop-blur-xl"
        style={{ background: "var(--pg-bg-card)", border: "1px solid var(--pg-border-strong)", boxShadow: "var(--pg-shadow)" }}>
        <div className="flex items-start gap-3">
          <ShieldCheck size={20} style={{ color: "var(--pg-gold)" }} className="shrink-0 mt-0.5" />
          <div className="text-sm" style={{ color: "var(--pg-text-secondary)" }}>
            <p className="font-semibold" style={{ color: "var(--pg-text-primary)" }}>Confidentialité & témoins (Loi 25 — Québec)</p>
            <p className="mt-1" style={{ color: "var(--pg-text-muted)" }}>
              PROGÈRE CRM utilise des témoins essentiels (session, sécurité) et, avec votre accord, des témoins optionnels
              (préférences, mesure d'audience), conformément à la <span style={{ color: "var(--pg-text-primary)" }}>Loi 25</span>.
            </p>
            <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs">
              <button onClick={() => navigate("/temoins")} data-testid="cookie-policy-link" className="hover:opacity-80" style={{ color: "var(--pg-gold)" }}>Politique de témoins</button>
              <button onClick={() => navigate("/confidentialite")} data-testid="cookie-privacy-link" className="hover:opacity-80" style={{ color: "var(--pg-gold)" }}>Confidentialité</button>
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 mt-4 sm:justify-end">
          <button onClick={() => choose("essentiels")} data-testid="cookie-refuse-btn"
            className="rounded-full text-sm px-4 py-2 transition-colors hover:opacity-80"
            style={{ border: "1px solid var(--pg-border-strong)", color: "var(--pg-text-primary)" }}>Refuser les témoins optionnels</button>
          <button onClick={() => choose("tous")} data-testid="cookie-accept-btn" className="btn-gold rounded-full text-sm px-4 py-2">Tout accepter</button>
        </div>
      </div>
    </div>
  );
}
